
//import errorHandler from './errorHandler'
import api from '../../../api'
import apiAsync from '../../../api/async'
import _ from 'lodash'

export default {
    get : (payload, next) => {
        api.get('/api/v1/tags?workspaceId=' + payload.query.workspaceId, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    getWithoutWorkspaceId : (next) => {
        api.get('/api/v1/tags', (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    getByType : (type, next) => {
        api.get('/api/v1/tags?typeName=' + type, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    create : (payload, next) => {
        api.post('/api/v1/tags', payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    addTagIntoCurrentWorkspace : (payload, next) => {
        api.put('/api/v1/workspaces/' + payload.query.workspaceId + '/usertags', payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    removeTagFromCurrentWorkspace : (payload, next) => {
        api.delete('/api/v1/workspaces/' + payload.query.workspaceId + '/usertags/' + payload.query.tagId, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    addTagIntoMessage : (payload, next) => {
        api.put('/api/v1/messages/' + payload.query.messageId + '/tags', payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    addTagIntoMessageAsync : async (payload) => {
        return await apiAsync.put('/api/v1/messages/' + payload.query.messageId + '/tags', payload.body)
    },
    removeTagFromMessage : (payload, next) => {
        api.delete('/api/v1/messages/' + payload.query.messageId + '/tags/' + payload.query.tagId, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/tagz.js